import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const ProcessContent = ({ setActiveFile }) => {
    const location = useLocation();
    const navigate = useNavigate();

    return (

        <>
            <Helmet>
                <title>Our Process | We Are A Site</title>
                <meta name="description" content="See how our smooth, step-by-step process helps you go from idea to launched website in no time." />
            </Helmet>
            <div className='CompanyInfoContent'>
                <div className='AboutWindowFunctionBar'>
                    <button
                        onClick={() => {
                            setActiveFile(null);
                            navigate('/about');
                        }}
                    >Back</button>
                    <button style={{ cursor: "not-allowed" }}>File</button>
                    <button style={{ cursor: "not-allowed" }}>Edit</button>
                    <button style={{ cursor: "not-allowed" }}>View</button>
                    <button style={{ cursor: "not-allowed" }}>Help</button>
                </div>
                <div className='CompanyInfoContentText'>
                    {/* <div className='CompanyInfoContentTextHeader'>
                    <img src='/images/NewsIcon.png' alt='Process' />
                    <div className='CompanyInfoContentTextInfo'>
                        <span className='BusinessAttribute BusinessName'>
                            <span className='BusinessLabel'>Document: </span>Process.txt
                        </span>
                        <span className='BusinessAttribute BusinessType'>
                            <span className='BusinessLabel'>Type: </span>Project Timeline
                        </span>
                    </div>
                </div> */}
                    <div className='CompanyInfoContentTextParagraph'>
                        <h1>Step-by-Step Process 😊</h1>
                        <ul>
                            <li>
                                <strong>Step 1: Initial Consultation</strong><br />
                                Free 1-on-1 meeting to gather your ideas and website goals.<br />
                                We'll note design preferences, features, and needs for your custom site.
                            </li>
                            <br />
                            <li>
                                <strong>Step 2: Follow-up Consultation + Design Preview</strong><br />
                                We show you a Figma mock-up of your future website (desktop + mobile)!<br />
                                We also discuss key setups like domain, login systems, email/text communications, and payments.
                            </li>
                            <br />
                            <li>
                                <strong>Step 3: Your Approval + Deposit Payment</strong><br />
                                Approve your designs! (Don't worry, you'll be allowed revisions as we update you regularly with progress.)<br />
                                Pay a 50% non-refundable deposit (of the total cost) to officially start the project.
                            </li>
                            <br />
                            <li>
                                <strong>Step 4: Communication + Progress Updates</strong><br />
                                Weekly project updates (or less/more often based on your preference).<br />
                                Easy to request design tweaks during this phase!
                            </li>
                            <br />
                            <li>
                                <strong>Step 5: Final Website Review</strong><br />
                                We present the final website version for you to check and approve.<br />
                                We'll discuss your warranty and support options if that is something that interests you.
                            </li>
                            <br />
                            <li>
                                <strong>Step 6: Handoff + Final Payment</strong><br />
                                Once you're happy, we hand over your new website!<br />
                                Remaining payment will be collected at this step.
                            </li>
                            <br />
                            <li>
                                <strong>Step 7: 60-Day Free Post-Launch Warranty</strong><br />
                                Free fixes and minor updates for 60 days after launch.<br />
                                Major changes may cost extra — we'll always let you know first!
                            </li>
                            <br />
                            <li>
                                <strong>Step 8: Managed Web Services - $150/month</strong><br />

                                Everything your business website needs—maintained, optimized, and ready to grow.<br /><br />

                                <strong>Included Services:</strong><br />
                                <ul className='MWS-List'>
                                    <li>
                                        <strong>Minor Bug Fixes</strong><br />
                                        Quick resolutions for small technical issues to keep your website running smoothly.
                                    </li>
                                    <li>
                                        <strong>Content Updates</strong><br />
                                        Add or update images, text, and sections as your business evolves.
                                    </li>
                                    <li>
                                        <strong>Search Engine Optimization (SEO) Services</strong><br />
                                        <ul>
                                            <li><strong>Keyword Research</strong> - Identify high-impact search terms</li>
                                            <li><strong>Backlink Generation</strong> - Build credibility through strategic links</li>
                                            <li><strong>Content Creation</strong> - Regular blog posts or updates optimized for search</li>
                                            <li><strong>Guest Posting Research</strong> - Discover outreach opportunities to grow authority</li>
                                        </ul>
                                    </li>
                                    <li>
                                        <strong>Analytics & Reporting</strong><br />
                                        Monthly reports with traffic trends, user behavior, and performance insights.
                                    </li>
                                    <li>
                                        <strong>Speed Testing & Optimization</strong><br />
                                        Routine checks to improve and maintain fast load times across devices.
                                    </li>
                                    <li>
                                        <strong>Hosting</strong><br />
                                        <ul>
                                            <li><strong>Webpages</strong> - Fully hosted on secure, reliable infrastructure</li>
                                            <li><strong>Backend Servers</strong> - Maintain APIs and dynamic functionality</li>
                                        </ul>
                                    </li>
                                    <li>
                                        <strong>Account Management</strong><br />
                                        <ul>
                                            <li><strong>Database Hosting</strong> - Manage and monitor storage for your app or site</li>
                                            <li><strong>Email Provider</strong> - Send and receive transactional or marketing emails</li>
                                            <li><strong>SMS Provider</strong> - Manage messaging services for client communication</li>
                                            <li><strong>Stripe Payments</strong> - Keep your payment gateway integrated and functional</li>
                                        </ul>
                                    </li>
                                </ul>

                                <strong>Note:</strong><br />
                                The $150/month price is based on standard traffic and usage. If your site experiences high traffic or requires a subset of these services, please contact us directly for a custom plan.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProcessContent;
